export default "__VITE_ASSET__CID6AoDc__"